// @flow
import * as React from 'react';

type Props = {
  children: React.Node,
};

export default ({ children }: Props) => (
  <div className="_Portal_StartupScreen_Wrapper_wrapper">
    {children}
  </div>
)